import React, { useState, useEffect } from 'react';
import { db } from '../LoginComp/firebase';

import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit,
  startAfter,
  getCountFromServer
} from 'firebase/firestore';

import './journal.css';

function Surgery() {

  const [surgeryBooks, setSurgeryBooks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lastVisible, setLastVisible] = useState(null);

  // Fetch Surgery Resources
  const fetchSurgeryBooks = async (page) => {

    try {

      const pageSize = 6;

      const resourcesRef = collection(db, 'mainresources');

      let q = query(
        resourcesRef,
        where('resourceType', '==', 'Surgery'),
        orderBy('created_at', 'desc'),
        limit(pageSize)
      );

      // Pagination
      if (page > 1 && lastVisible) {
        q = query(
          resourcesRef,
          where('resourceType', '==', 'Surgery'),
          orderBy('created_at', 'desc'),
          startAfter(lastVisible),
          limit(pageSize)
        );
      }

      const querySnapshot = await getDocs(q);

      const books = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setSurgeryBooks(books);

      setLastVisible(
        querySnapshot.docs[querySnapshot.docs.length - 1]
      );

      // Count total docs
      const countSnapshot = await getCountFromServer(
        query(
          resourcesRef,
          where('resourceType', '==', 'Surgery')
        )
      );

      setTotalPages(
        Math.ceil(countSnapshot.data().count / pageSize)
      );

    } catch (error) {
      console.error('Error fetching Surgery resources:', error);
    }
  };

  const paginate = (page) => {
    setCurrentPage(page);
    fetchSurgeryBooks(page);
  };

  useEffect(() => {
    fetchSurgeryBooks(currentPage);
  }, [currentPage]);

  return (
    <div className="journal-page-container">

      {/* HERO */}
      <section className="hero">

        <div className="hero-image">
          <img src="/imgbook.png" alt="Surgery Resources" />
        </div>

        <div className="hero-content">

          <h1>Eye Care Digital Library</h1>

          <p>
            Explore surgical ophthalmology resources covering
            cataract surgery, refractive procedures, corneal
            surgeries, and advanced ophthalmic surgical techniques.
          </p>

        </div>

      </section>

      {/* HEADER */}
      <div className="journal-heading-section">

        <h2>Surgery</h2>

        <p>
          Access clinical and academic materials on ophthalmic surgery,
          modern techniques, pre-operative and post-operative care,
          and surgical innovations in eye care.
        </p>

      </div>

      {/* BOOK GRID */}
      <div className="articles-container">

        {surgeryBooks.length > 0 ? (

          surgeryBooks.map((book) => (

            <div key={book.id} className="article-item">

              {book.coverImageURL && (
                <img
                  src={book.coverImageURL}
                  alt={book.title}
                  className="book-cover-image"
                />
              )}

              <h4>{book.title}</h4>

              <div className="book-meta-data">

                {book.author && (
                  <p><strong>Author:</strong> {book.author}</p>
                )}

                {book.publication_year && (
                  <p><strong>Year:</strong> {book.publication_year}</p>
                )}

                {book.isbn && (
                  <p><strong>ISBN:</strong> {book.isbn}</p>
                )}

              </div>

              {book.description && (
                <p className="book-description">
                  {book.description}
                </p>
              )}

              {book.pdfFileURL && (
                <a
                  href={book.pdfFileURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="read-article-btn"
                >
                  Read Book
                </a>
              )}

            </div>

          ))

        ) : (
          <div className="no-books-found">
            <h3>No Resources Available</h3>
            <p>No Surgery resources have been uploaded yet.</p>
          </div>
        )}

      </div>

      {/* PAGINATION */}
      {totalPages > 1 && (
        <div className="pagination-container">

          <button
            className="pagination-button"
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              className={`pagination-button ${currentPage === i + 1 ? 'active' : ''}`}
              onClick={() => paginate(i + 1)}
            >
              {i + 1}
            </button>
          ))}

          <button
            className="pagination-button"
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>

        </div>
      )}

    </div>
  );
}

export default Surgery;